"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = ({
  size = 36,
  width = size,
  height = size,
  ...restProps
}) => /*#__PURE__*/_react.default.createElement("svg", _extends({
  width: width,
  height: height,
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, restProps), /*#__PURE__*/_react.default.createElement("path", {
  d: "M22.3064 8.41255C22.3064 8.08331 22.0395 7.81641 21.7103 7.81641H11.0432C10.006 7.81641 9.16602 8.65644 9.16602 9.69362V22.2247C9.16602 22.5612 9.43883 22.834 9.77537 22.834C10.1119 22.834 10.3847 22.5612 10.3847 22.2247V10.0087C10.3847 9.45641 10.8324 9.0087 11.3847 9.0087H21.7103C22.0395 9.0087 22.3064 8.74179 22.3064 8.41255Z",
  fill: "#737F8F"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M24.1228 10.5645H13.7981C12.761 10.5645 11.9209 11.4045 11.9209 12.4417V25.5821C11.9209 26.6192 12.7609 27.4593 13.7981 27.4593H24.1228C25.1599 27.4593 26 26.6193 26 25.5821V12.4417C25.9999 11.4045 25.1599 10.5645 24.1228 10.5645ZM24.4 26H13.4V12H24.4V26Z",
  fill: "#121213"
}));

exports.default = _default;